import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { useIntl } from "react-intl";
import { toLower } from "lodash-es";
import { IProductionDashboardStepDTO } from "../../models/DTO/Production/IProductionResponseDTO";

interface ProductionThroughputChartProps {
    steps: IProductionDashboardStepDTO[];
}

const ProductionThroughputChart: React.FC<ProductionThroughputChartProps> = ({ steps }) => {
    const intl = useIntl();
    const styles = getComputedStyle(document.documentElement);
    const highlightColor = styles.getPropertyValue("--highlight-color").trim() || "#f5a623";
    const primaryColor = styles.getPropertyValue("--primary").trim() || "#4a90d9";

    const chartData = steps.map((step) => ({
        name: intl.formatMessage({ id: toLower(step.stepName), defaultMessage: step.stepName }),
        "Current Count": step.serialCount,
        "Daily Throughput": step.dailyThroughput,
    }));

    return (
        <div className="pd-chart">
            <h5 className="pd-chart__title mb-3">Throughput Overview</h5>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={chartData} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--minor-bg-color)" />
                    <XAxis dataKey="name" tick={{ fill: "var(--main-text-color)", fontSize: 12 }} stroke="var(--minor-bg-color)" />
                    <YAxis tick={{ fill: "var(--main-text-color)", fontSize: 12 }} stroke="var(--minor-bg-color)" />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: "var(--secondary-bg-color)",
                            border: "1px solid var(--minor-bg-color)",
                            color: "var(--main-text-color)",
                        }}
                        cursor={{ fill: "var(--minor-bg-color)", opacity: 0.3 }}
                    />
                    <Legend />
                    <Bar dataKey="Current Count" fill={highlightColor} />
                    <Bar dataKey="Daily Throughput" fill={primaryColor} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default ProductionThroughputChart;
